import { ChangeEvent, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'
import 'simplebar-react/dist/simplebar.min.css'
import { useDebounceCallback } from 'usehooks-ts'


import { cn } from '@shared/lib/cn'
import Accordion from '@shared/ui/accordion'
import Checkbox from '@shared/ui/checkbox'
import Input from '@shared/ui/input'
import ScrollArea from '@shared/ui/scroll-area'

import styles from './styles.module.scss'


export interface FilterContainsProps {
  values: {
    name: string;
    value: string;
  }[];
  name: string;
  defaultOpen?: boolean;
  withSearch?: boolean;
  selected?: string[];
  onChange?: (value: string, checked: boolean) => void;
}

export default function FilterContains (props: FilterContainsProps) {
  const { t: tc } = useTranslation('common')
  const [ searchValue, setSearchValue ] = useState<string>('')
  const [ debouncedValue, setDebouncedValue ] = useState<string>('')

  const debounce = useDebounceCallback((value: string) => {
    setDebouncedValue(value)
  }, 300)

  const {
    values,
    name,
    defaultOpen = false,
    withSearch = false,
    selected,
  } = props

  const FILTERED_VALUES = useMemo(() => {
    return values.filter((v) =>
      v.name.toLowerCase().includes(debouncedValue.toLowerCase()),
    )
  }, [ values, debouncedValue ])

  return (
    <Accordion
      triggerClassName={styles['trigger-wrapper']}
      trigger={
        <button type="button" className={cn('reset-button', styles.trigger)}>
          {name}
        </button>
      }
      content={
        <div className={styles.wrapper}>
          {withSearch && (
            <Input
              className={styles.search}
              placeholder={tc('search')}
              inputSize="large"
              value={searchValue}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                setSearchValue(e.target.value)
                debounce(e.target.value)
              }}
              endDecorator={<ReactSVG src="/icons/search.svg" wrapper="span" />}
              endDecoratorClassName={styles['input-end-decorator']}
            />
          )}

          <ScrollArea maxHeight={180}>
            {FILTERED_VALUES.map((i) => {
              return (
                <span className={styles.filter} key={i.name}>
                  <Checkbox
                    className={styles.filter}
                    label={i.name}
                    checkboxSize="small"
                    checked={selected?.includes(i.value) || false}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                      props.onChange?.(i.value, e.target.checked)
                    }}
                  />
                </span>
              )
            })}
          </ScrollArea>
        </div>
      }
      defaultOpen={defaultOpen}
    ></Accordion>
  )
}
